import React, { useEffect, useState } from 'react';
import Loader from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import * as staffActions from '../../Redux/Actions/staff';
import { toastMessage } from '../../utils/toast';
import { validationError } from '../../utils/initiate';

const AddStaff = () => {

    const [loading, setLoading] = useState(false);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    const [emiratesId, setEmiratesId] = useState('');
    // const [extensionNumber, setExtensionNumber] = useState('');

    const [departmentsList, setDepartmentsList] = useState([]);
    const [masterProcessList, setMasterProcessList] = useState([]);
    const [processList, setProcessList] = useState([]);
    const [departmentID, setDepartmentID] = useState('');
    const [masterProcessID, setMasterProcessID] = useState('');
    // const [selectedDepartment, setSelectedDepartment] = useState([]);
    const [selectedMasterProcess, setSelectedMasterProcess] = useState([]);
    const [selectedProcess, setSelectedProcess] = useState([]);
    const [buttonLoading, setButtonLoading] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        handleGetAllServices();
    }, []);

    const handleGetAllServices = () => {
        setLoading(true);
        staffActions.getAllServices().then(res => {
            if(res && res.data){
                setLoading(false);
                setDepartmentsList(res.data.departments);
            }else{
                toastMessage('error', 'Unable to load the process');
            }
        }).catch(err => {
            toastMessage('error', `Unable to load the process`);
        });
    };

    const handleList = (key, ID) => {
        let list = [];
        if (key === 'department'){
            list = departmentsList.filter(({id}) => id === ID)[0].masterProcess;
            setMasterProcessList(list);
        }
        else{
            list = masterProcessList.filter(({id}) => id === ID)[0].process;
            setProcessList(list);
        }
    };

    // const handleSelectedDepartment = (event) => {
    //     let list = departmentsList.filter(({id}) => id === parseInt(event.target.value, 10))[0].masterProcess;
    //     if (event.target.checked){
    //         setSelectedDepartment([...selectedDepartment, parseInt(event.target.value, 10)]);
    //         list = list.map(({id}) => id);
    //         let newList = [...list, ...selectedMasterProcess]
    //         let rmDuplicates = [...new Set(newList)];
    //         setSelectedMasterProcess(rmDuplicates);
    //     }else{
    //         const newList = selectedDepartment.map(item => (item === parseInt(event.target.value, 10)) ? false : item).filter(Boolean);
    //         setSelectedDepartment(newList)
    //         list.map(({id}) => {
    //             let Index = selectedMasterProcess.indexOf(id);
    //             return (Index === -1) ? '' : selectedMasterProcess.splice(Index, 1);
    //         });
    //         setSelectedMasterProcess(selectedMasterProcess);
    //     }
    // };
  
    const handleSelectedMasterProcess = (event, deptID, mpID) => {
        let mpList = departmentsList.filter(({id}) => id === parseInt(deptID, 10))[0].masterProcess;
        mpList = mpList.filter(({id}) => id === parseInt(mpID, 10))[0].process;
        if (event.target.checked) {
            mpList = mpList.map(({id}) => id);
            let newList = [...mpList, ...selectedProcess];
            let rmDuplicates = [...new Set(newList)];
            setSelectedProcess(rmDuplicates);
            setSelectedMasterProcess([...selectedMasterProcess, parseInt(event.target.value, 10)]);
        } else {
            const newList = selectedMasterProcess.map(item => (item === parseInt(event.target.value, 10)) ? false : item).filter(Boolean);
            setSelectedMasterProcess(newList);
            mpList.map(({id}) => {
                let Index = selectedProcess.indexOf(id);
                return (Index === -1) ? '' : selectedProcess.splice(Index, 1);
            });
            setSelectedProcess(selectedProcess);
        }
    };

    const handleSelectedProcess = (event, mpID) => {
        let pList = masterProcessList.filter(({id}) => id === parseInt(mpID, 10))[0].process;
        if (event.target.checked) {
            let updatedP = [...selectedProcess, parseInt(event.target.value, 10)];
            let updatedMP = [];
            if (pList.length === 1) {
                updatedMP = [...selectedMasterProcess, parseInt(mpID, 10)];
            } else {
                let multipleP = [];
                pList.forEach(({id}) =>
                    updatedP.includes(id) ? multipleP.push(id) : ''
                );
                updatedMP = (pList.length === multipleP.length) ? [...selectedMasterProcess, parseInt(mpID, 10)] : selectedMasterProcess;
            }
            setSelectedMasterProcess(updatedMP);
            setSelectedProcess(updatedP);
        } else {
            const mPList = selectedMasterProcess.map(item => (item === mpID) ? false : item).filter(Boolean);
            setSelectedMasterProcess(mPList);
            const newList = selectedProcess.map(item => (item === parseInt(event.target.value, 10)) ? false : item).filter(Boolean);
            setSelectedProcess(newList);
        }
    };
      
    // const isDeptChecked = (id) => selectedDepartment.find(item => item === parseInt(id, 10));
    const isMPChecked = (id) => {
        let response = selectedMasterProcess.find(item => item === parseInt(id, 10));
        return (response === undefined) ? false : response;
    };
    const isPChecked = (id) => {
        let response = selectedProcess.find(item => item === parseInt(id, 10));
        return (response === undefined) ? false : response;
    };

    const handleAddStaff = () => {
        setButtonLoading(true);
        if((name !== '') && (email !== '') && (mobileNumber !== '') && (selectedProcess.length !== 0)){
            let payload = {
                name, email, mobileNumber, emiratesId, extensionNumber: '', skillIds: selectedProcess
            };
            staffActions.create(payload).then(res => {
                if(res && res.data){
                    toastMessage('success', `Staff added successfully`);
                    setName(''); setEmail(''); setMobileNumber(''); setEmiratesId(''); setSelectedMasterProcess([]); setSelectedProcess([]);
                }else{
                    toastMessage('error', 'Email or Mobile number is already Exists');
                }
                setButtonLoading(false);
            }).catch(err => {
                (err.response.status === 400) && err.response && validationError(err.response);
                (err.response.status === 400) && err.response && err.response.data && err.response.data.message && toastMessage('error', err.response.data.message);
                setButtonLoading(false);
            });
        }else{
            setButtonLoading(false);
            toastMessage('error', `Enter the correct staff details`);
        }
    };

    return(
        <>
            <div className="row">
                <div className="col-lg-12 col-xxl-12">
                    {loading ? <div className='min-vh-100 d-flex align-items-center justify-content-center'><Loader type="ThreeDots" color="#2d207d" height={40} width={40} /></div>
                    : <div className="card border-0 card-stretch">
                        <div className="card-header border-0 py-3">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label font-weight-bolder text-dark">{t("staffManagement.addStaff.title")}</span>
                            </h3>
                        </div>
                        <div className="card-body pt-0 pb-3">
                            <div className="mb-3">
                                <label className="form-label mb-1">{t("staffManagement.addStaff.name")} <span className="text-danger">*</span></label>
                                <input placeholder={t("staffManagement.addStaff.namePlaceholder")} type="text" className="form-control"
                                    name="name" value={name} onChange={e => setName(e.target.value)}
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label mb-1">{t("staffManagement.addStaff.email")} <span className="text-danger">*</span></label>
                                <input placeholder={t("staffManagement.addStaff.emailPlaceholder")} type="text" className="form-control"
                                    name="email" value={email} onChange={e => setEmail(e.target.value)}
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label mb-1">{t("staffManagement.addStaff.mobileNumber")} <span className="text-danger">*</span></label>
                                <input placeholder={t("staffManagement.addStaff.mobileNumberPlaceholder")} type="text" className="form-control"
                                    name="mobileNumber" value={mobileNumber} onChange={e => setMobileNumber(e.target.value)}
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label mb-1">{t("staffManagement.addStaff.emiratesID")} <span className="text-danger">*</span></label>
                                <input placeholder={t("staffManagement.addStaff.emiratesIDPlaceholder")} type="text" className="form-control"
                                    name="mobileNumber" value={emiratesId} onChange={e => setEmiratesId(e.target.value)}
                                />
                            </div>
                            {/* <div classNarow mb-3">
                                <label className="form-label mb-1">Extension Number <span className="text-danger">*</span></label>
                                <input placeholder={`Enter the extension number`} type="text" className="form-control"
                                    name="extensionNumber" value={extensionNumber} onChange={e => setExtensionNumber(e.target.value)}
                                />
                            </div> */}
                            <div className="mb-3">
                                <label className="form-label mb-2">{t("staffManagement.addStaff.department")} <span className="text-danger">*</span></label>
                                <div>
                                    {departmentsList.map(({name, id}, index) => 
                                        <div className='d-flex flex-column' key={id}>
                                            <div key={id} className='d-flex align-items-center mb-2 c-pointer'>
                                                <span className="me-1">{index+1}.</span>
                                                {/* <input type='checkbox' className='me-2' value={id} checked={isDeptChecked(id)} onChange={handleSelectedDepartment} /> */}
                                                <p className="m-0" onClick={() => {handleList('department', id); setDepartmentID(id === departmentID ? '' : id)}}>{name}</p>
                                            </div>
                                            {(departmentID === id) && (masterProcessList.length !== 0) && <div className="mb-3 ms-4">
                                                <label className="form-label mb-1">{t("staffManagement.addStaff.masterProcess")}</label>
                                                <div>
                                                    {masterProcessList.map(({name, id: mpID}) =>
                                                        <div className="d-flex flex-column" key={mpID}>
                                                            <div key={mpID} className='d-flex align-items-center mb-1 c-pointer'>
                                                                <input type='checkbox' className='me-2' name={name} id={name} value={mpID}
                                                                    checked={isMPChecked(mpID)} onChange={e => handleSelectedMasterProcess(e, id, mpID)} />
                                                                <p className="m-0" onClick={() => {handleList('masterProcess', mpID); setMasterProcessID(mpID === masterProcessID ? '' : mpID)}}>{name}</p>
                                                            </div>
                                                            {(masterProcessID === mpID) && (processList.length !== 0) && <div className="mb-3 ms-4">
                                                                <label className="form-label mb-1">{t("staffManagement.addStaff.process")}</label>
                                                                <div>
                                                                    {processList.map(({name, id: pID}) =>
                                                                        <div key={pID} className='d-flex align-items-center mb-1 c-pointer'>
                                                                            <input type='checkbox' className='me-2' name={name} id={name} value={pID}
                                                                                checked={isPChecked(pID)} onChange={e => handleSelectedProcess(e, mpID)} />
                                                                            <label className="m-0" htmlFor={name}>{name}</label>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <button disabled={loading} onClick={handleAddStaff} type="button" className="d-flex align-items-center btn btn-primary font-weight-bold my-4">
                                {t("staffManagement.addStaff.title")} {buttonLoading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                            </button>
                        </div>
                    </div>}
                </div>
            </div>
        </>
    );
};

export default AddStaff;